import { rawData } from "../rawData";
import config from "../config.json";

const { dataSettings } = config;
const { uid } = dataSettings;
const getAllMetadataFromIds = (arrayOfIds) => {
  const filteredData = rawData.filter((d) => arrayOfIds.includes(d[uid]));

  // Remove "lookups"
  const selectedMetadata = [];
  for (const datum of filteredData) {
    const objToAdd = {};
    for (const objKey of Object.keys(datum)) {
      if (objKey !== "lookups") {
        objToAdd[objKey] = datum[objKey];
      }
    }
    selectedMetadata.push(objToAdd);
  }

  return selectedMetadata;
};

export { getAllMetadataFromIds };
